import React from 'react';
import { Box, Typography } from '@mui/material';
import FuncionarioForm from '../components/funcionario/FuncionarioForm';

const FuncionarioNovo: React.FC = () => {
  return (
    <Box>
      <Typography 
        variant="h4" 
        component="h1" 
        gutterBottom 
        sx={{ 
          fontWeight: 'bold',
          fontFamily: 'Arial, sans-serif',
          fontSize: '2.125rem',
          lineHeight: 1.235
        }}
      >
        Novo Funcionário
      </Typography>
      <FuncionarioForm />
    </Box>
  );
};

export default FuncionarioNovo;
